
import { format } from "date-fns";
import { EventObject } from "./types";

interface DayViewProps {
	currentDate: Date;
}

export const DayView = ({ currentDate }: DayViewProps) => {
	return (
		<div className="h-full flex flex-col items-center justify-center">
			<h3 className="font-medium">Day View</h3>
			<p className="text-muted-foreground">
				{format(currentDate, 'MMMM d, yyyy')}
			</p>
			<p className="text-sm text-muted-foreground mt-4">
				Switch to Week view to see a detailed calendar with time slots
			</p>
		</div>
	);
};
